import axios from "axios";
import { received } from "../DocumentationReducer";
import { baseURL } from "../thunks";

export const putDocumentACL =
  ({ id, ACLList }) =>
  async (dispatch) => {
    console.log("putDocumentACL called", { ACLList });
    try {
      const putReq = await axios({
        method: "put",
        url: baseURL + "documentation/documents/" + id + "/acl",
        data: ACLList,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      console.log({ putReq });
      return putReq;
    } catch (error) {
      console.log(error);
      dispatch(received({ error: true }));
    }
  };
